<template>
  <div class="btn-group btn-group-fancy" :class="{'btn-group-buttons': type === 'button'}" data-toggle="buttons">
    <slot>
      <template v-if="type === 'radio' || type === 'checkbox'">
        <label v-for="item in data" class="btn btn-sm btn-primary" :class="{ 'active': value == item.value }" @click="click(item)">
          <input type="radio" v-model="item.active" :value="item.value"> {{ item.title }}
        </label>
      </template>

      <template v-if="type === 'button'">
        <button v-for="item in data" class="btn btn-sm btn-primary" :class="{ 'active': value == item.value }" @click="click(item)">
          {{ item.title }}
        </button>
      </template>
    </slot>
  </div>
</template>


<script>
export default {
  name: 'AppButtonGroup',

  props: {
    type: {
      type: String,
      default: 'button',
    },

    data: {
      type: Array,
      default: null,
    },

    value: {
      required: true,
    }
  },

  methods: {
    click(item) {
      this.$emit('click', item);
      this.$emit('change', item);
      this.$emit('input', item.value);
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/AppButtonGroup.vue